import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import EnButton from 'Components/base/EnButton/EnButton.vue';
import EnEditableDataFieldsViewSection from 'Components/forms/EnEditableDataFieldsViewSection/EnEditableDataFieldsViewSection.vue';
import { enFetch } from 'Js/utils/fetchUtils';
import { EnButtonVariants } from 'Components/types/EnButtonVariants';
export default {
  __name: 'externalTab',
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: /*@__PURE__*/_mergeModels(['input', 'update:modelValue', 'message-receive'], ["update:modelValue"]),
  setup(__props, _ref) {
    let __expose = _ref.expose,
      __emit = _ref.emit;
    __expose();
    const _useI18n = useI18n(),
      t = _useI18n.t;
    const modelValue = _useModel(__props, 'modelValue');
    const emit = __emit;
    const user = computed({
      get() {
        return modelValue.value;
      },
      set(value) {
        emit('input', value);
        emit('update:modelValue', value);
      }
    });
    const availableProviders = computed(() => {
      const others = user.value && user.value.OtherLogins ? user.value.OtherLogins : [];
      const currentNames = user.value && user.value.CurrentLogins ? user.value.CurrentLogins.map(c => c.LoginProvider) : [];
      return others.filter(p => !currentNames.includes(p.Name));
    });
    async function disconnectAd(loginProvider, providerKey) {
      const model = new URLSearchParams({
        loginProvider,
        providerKey
      });
      const res = await enFetch({
        url: "/api/Configuration/RemoveExternalLogin?".concat(model),
        method: 'post'
      });
      if (res.ok) {
        emit('message-receive', t('Authentication.manage.external.disconnectSuccess'), 'success');
        const loginValue = user.value.CurrentLogins.find(login => login.LoginProvider === loginProvider && login.ProviderKey === providerKey);
        user.value.OtherLogins.push({
          DisplayName: loginValue.ProviderDisplayName,
          Name: loginValue.LoginProvider
        });
        user.value.CurrentLogins = user.value.CurrentLogins.filter(login => !(login.LoginProvider === loginProvider && login.ProviderKey === providerKey));
      } else {
        emit('message-receive', await res.text(), 'error');
      }
    }
    async function connectAd(provider) {
      window.open("/api/Configuration/LinkLoginWithAd?provider=".concat(provider.Name), '_self');
    }
    function getInitials() {
      let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return name.split(' ').map(n => n[0]).join('').toUpperCase();
    }
    const __returned__ = {
      t,
      modelValue,
      emit,
      user,
      availableProviders,
      disconnectAd,
      connectAd,
      getInitials,
      computed,
      get useI18n() {
        return useI18n;
      },
      EnButton,
      EnEditableDataFieldsViewSection,
      get enFetch() {
        return enFetch;
      },
      get EnButtonVariants() {
        return EnButtonVariants;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};